import React from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';

interface SpinnerProps {
  size?: number;
  color?: string;
  borderColor?: string;
}

const LoadingSpinner: React.FC<SpinnerProps> = ({
  size = 50,
  color = theme.colors.blue,
  borderColor = theme.colors.blueLight,
}) => {
  const classes = useStyles({ size, color, borderColor });

  return <div className={classes.spinner} />;
};

const useStyles = createUseStyles({
  spinner: {
    width: ({ size }: SpinnerProps) => size,
    height: ({ size }: SpinnerProps) => size,
    border: ({ borderColor }: SpinnerProps) => `4px solid ${borderColor}`,
    borderRadius: '50%',
    borderTop: ({ color }: SpinnerProps) => `4px solid ${color}`,
    animation: '$spin 1s linear infinite',
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
});

export default LoadingSpinner;
